import React, { memo } from 'react';
import getProductProps from '../../../get-product-props';

import ProductDetails from './product-details';
import ProductFooter from './product-footer';

import './product-tile.less';

export default memo(({ product: sourceProduct, options, analyticsData, trackCustomMetric, lazyLoad }) => {
    const productProps = getProductProps(
        sourceProduct,
        null,
        {},
        { ...(options || {}), visId: true, allianceBadge: false },
        analyticsData,
        trackCustomMetric,
    );
    const { ratings, productLinkProps, product } = productProps || {};
    return (
        <div className="visid-poduct-tile">
            <ProductDetails
                product={product}
                ratings={ratings}
                productLinkProps={productLinkProps}
                analyticsData={analyticsData}
                options={options}
                lazyLoad={lazyLoad}
            />
            <ProductFooter
                product={product}
                productLinkProps={productLinkProps}
                analyticsData={analyticsData}
                options={options}
            />
        </div>
    );
});
